import SectionLabel from "@/components/base/SectionLabel";
import { timeline } from "@/mocks/site";

export default function Timeline() {
  return (
    <section className="relative overflow-hidden bg-foreground-950 py-16 text-background-50 md:py-24">
      <div className="blueprint absolute inset-0 opacity-40" />
      <div className="relative mx-auto w-full max-w-shell px-4 md:px-6">
        <div className="mb-10 flex flex-col justify-between gap-5 md:mb-14 lg:flex-row lg:items-end">
          <div>
            <SectionLabel tone="light" className="mb-5">
              Meilensteine
            </SectionLabel>
            <h2 className="font-heading text-[28px] font-extrabold leading-[1.08] tracking-tightest sm:text-[34px] md:text-[42px]">
              1963 bis heute.
            </h2>
          </div>
          <p className="max-w-md text-[14px] leading-relaxed text-background-400">
            Vom Ein-Mann-Betrieb mit Geländern und kleinen Sondermaschinen zum Familienunternehmen
            mit eigener Halle, CNC-Fertigung und drei Geschäftsbereichen.
          </p>
        </div>

        <div className="border-t border-foreground-800">
          {timeline.map((item) => (
            <div
              key={item.year}
              className="group grid grid-cols-1 gap-2 border-b border-foreground-800 py-6 transition-colors hover:bg-foreground-900/60 md:grid-cols-12 md:gap-6 md:py-7"
            >
              <div className="md:col-span-2">
                <span className="font-label text-[12px] tracking-[0.16em] text-primary-400">
                  {item.year}
                </span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-heading text-[17px] font-bold leading-snug text-background-50 md:text-[19px]">
                  {item.title}
                </h3>
              </div>
              <div className="md:col-span-6">
                <p className="text-[13px] leading-relaxed text-background-400 md:text-[13.5px]">
                  {item.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}